import React from 'react';
// import * as Actions from '@/app/store/actions';
import { Avatar, CircularProgress } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
// import axios from '@shared/axios-shared';
import dayjs from 'dayjs';
// import html2pdf from 'html2pdf.js';
import { Fragment } from 'react';
// import { useDispatch } from 'react-redux';
// import { useReactToPrint } from 'react-to-print';
import MediaRenderer from './MediaRenderer';
// import SendEmailDialog from './SendEmailDialog';
// import { Buffer } from 'buffer';
import ModalBase from '@/app/customComponents/modals/ModalBase';

// function getBase64(url) {
// 	return new Promise((resolve, reject) => {
// 		const axiosInstance = axios.create({
// 			headers: {
// 				'Cache-Control': 'no-cache',
// 				Pragma: 'no-cache',
// 				Expires: '0',
// 				Authorization: '',
// 			},
// 		});
// 		delete axiosInstance.defaults.headers.common['Authorization'];
// 		axiosInstance
// 			.get(url, {
// 				responseType: 'arraybuffer',
// 			})
// 			.then((res) => {
// 				resolve(
// 					`data:image/${url.split('.').slice(-1)[0]};base64,${Buffer.from(res.data, 'binary').toString('base64')}`,
// 				);
// 			})
// 			.catch((err) => {
// 				reject(err);
// 			});
// 	});
// }

// async function replaceImageUrlsWithData(html) {
// 	const doc = html;
// 	const images = doc.querySelectorAll('img');

// 	const urls = [];
// 	for (const image of images) {
// 		urls.push(image.src);
// 	}

// 	// Fetch all URLs in parallel
// 	const responses = await Promise.all(urls.map((url) => getBase64(url)));
// 	for (let i = 0; i < images.length; i += 1) {
// 		images[i].src = responses[i];
// 	}
// 	return doc;
// }

const ActivityViewModal = ({
	student,
	studentActivity,
	loader,
	// pdfRef,
	date,
	open,
	setOpen,
}) => {
	// const [sendLoader, setSendingLoader] = useState(false);
	// const dispatch = useDispatch();

	// async function customPrintFunction(printIframe) {
	// 	const document = printIframe.contentDocument;
	// 	if (document) {
	// 		try {
	// 			const opts = {
	// 				html2canvas: {
	// 					backgroundColor: 'rgba(0,0,0,0)',
	// 					removeContainer: true,
	// 				},
	// 			};
	// 			const html = document.getElementsByTagName('html')[0];
	// 			const modifiedHTML = await replaceImageUrlsWithData(html);
	// 			await html2pdf()
	// 				.set(opts)
	// 				.from(modifiedHTML)
	// 				.toPdf()
	// 				.get('pdf')
	// 				.then((pdf) => {
	// 					dispatch(
	// 						Actions.openDialog({
	// 							children: <SendEmailDialog pdf={pdf} student={student} />,
	// 						}),
	// 					);
	// 					setSendingLoader(true);
	// 				});
	// 		} catch (error) {
	// 			setSendingLoader(false);
	// 		}
	// 	}
	// }

	// const sendPdfEmail = useReactToPrint({
	// 	content: () => pdfRef.current,
	// 	documentTitle: `${student.first_name} ${student.last_name} Activity Report.pdf`,
	// 	copyStyles: true,
	// 	print: customPrintFunction,
	// 	onBeforeGetContent: () => {
	// 		return new Promise((resolve) => {
	// 			const interval = setInterval(() => {
	// 				const images = Array.from(document.querySelectorAll('img')).filter((img) => {
	// 					return window.getComputedStyle(img).display !== 'none';
	// 				});
	// 				const allImagesLoaded = Array.from(images).every((img) => img.complete && img.naturalHeight !== 0);
	// 				if (allImagesLoaded) {
	// 					clearInterval(interval);
	// 					resolve();
	// 				}
	// 			}, 100);
	// 		});
	// 	},
	// });

	const handleCloseModal = () => {
		setOpen(false);
	};

	return (
		<ModalBase hasPadding={false} maxWidth="500px" open={open} setOpen={setOpen} showClose={false} showX={false}>
			<div>
				<div className="p-16 bg-pd-blue rounded-t-lg py-32">
					<button
						className="absolute top-10 right-10 text-white cursor-pointer"
						onClick={handleCloseModal}
						type="button"
					>
						<Close />
					</button>

					<div className="flex items-center flex-wrap justify-between">
						<span className="text-pd-xl font-bold">
							<div className="text-pd-lg truncate flex items-center gap-16">
								<Avatar src={student.thumb} style={{ width: '40px', height: '40px' }} />
								<span className="text-white">
									{student.first_name} {student.last_name}
								</span>
							</div>
						</span>
						<div className="flex justify-between">
							<div className="flex">
								<div className="flex flex-col items-end" style={{ color: '#fff', marginRight: '22px' }}>
									<span>Daily Report</span>
									<span>
										{date
											? dayjs(new Date(date.replace(/-/g, '/'))).format('MMMM DD, YYYY')
											: dayjs().format('MMMM DD, YYYY')}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="overflow-y-auto py-16 h-[355px]">
					{loader ? (
						<div className="flex justify-center items-center h-full">
							<CircularProgress size={35} />
						</div>
					) : (
						<>
							<div className="flex flex-col-reverse mt-10">
								{studentActivity.length === 0 ? (
									<div className="flex justify-center items-center h-full">
										<div className="flex flex-col items-center">No Activity for today</div>
									</div>
								) : null}
								{studentActivity.map((obj, index) => {
									return (
										(obj.type === 'checkin' && (
											<div className="py-[11px] pl-[30px] pr-[10px]" key={index}>
												<div className="text-pd-xl self-end font-bold mr-28 my-4">
													<div className="flex">
														<div className="rounded-full bg-success-green text-white p-[5px] h-[40px] w-[40px] flex justify-center items-center">
															<Check color="white" />
														</div>
														<div className="flex flex-col items-start ml-[14px]">
															<div className="text-[13px] pb-[4px]">
																Checked in at {dayjs(`${obj.data.checkin_date}Z`).format('hh:mm A')}
															</div>
														</div>
													</div>
												</div>
											</div>
										)) ||
										(obj.type === 'checkout' && (
											<div className="py-[11px] pl-[30px] pr-[10px]" key={index}>
												<div className="text-pd-xl self-end font-bold mr-28">
													<div className="flex border-b pb-10">
														<div className="rounded-full bg-success-green text-white p-[5px] h-[40px] w-[40px] flex justify-center items-center">
															<Check color="white" />
														</div>
														<div className="flex flex-col items-start ml-[14px]">
															<div className="text-[13px] pb-[4px]">
																Checked out at {dayjs(`${obj.data.checkout_date}Z`).format('hh:mm A')}
															</div>
														</div>
													</div>
												</div>
											</div>
										)) ||
										(obj.type === 'activities' && (
											<Fragment key={index}>
												{obj.data?.map((activity) => {
													return (
														<div className="py-[11px] pl-[30px] pr-[10px] " key={activity.id}>
															<div className="text-pd-xl self-end font-bold mr-28">
																<div className="flex border-b pb-10">
																	<Avatar src={activity.activity.photo} />
																	<div className="flex flex-col items-start ml-[14px]">
																		<div className="text-[13px] pb-[4px]">
																			{activity.activity.name} at {dayjs(activity.created_at).format('hh:mm A')}
																		</div>
																		<div className="text-[13px] pb-[4px] text-[#676767]">
																			{activity.activity_id !== 9 ? activity.activity.name : null}
																			{activity.activity_id === 9 ? activity.activities.name : null}
																			{activity?.activities?.types && activity.activity_id !== 12
																				? ` - ${activity?.activities?.types}`
																				: ''}
																			{activity.package ? ` - ${activity.package}` : ''}
																			{activity.activity_id !== 9 && activity?.start_time
																				? ` - ${activity?.start_time.split(' ').slice(1, 3).join(' ')}`
																				: ''}
																			{activity.activity_id !== 9 && activity?.end_time
																				? ` to ${activity?.end_time.split(' ').slice(1, 3).join(' ')}`
																				: ''}
																			{activity?.activities?.bullet_comments
																				? ` - ${activity?.activities?.bullet_comments}`
																				: ''}
																			{activity?.activities?.quick_comments
																				? ` - ${activity?.activities?.quick_comments}`
																				: ''}
																			{activity.activity_id === 10 && activity.activity_supplies.length > 0
																				? `: ${activity?.activity_supplies
																						?.map((supply) => supply.supply_name)
																						.join(' - ')}`
																				: ''}
																			{activity.other_comment ? ` - ${activity.other_comment}` : ''}
																		</div>
																		{activity.photo || activity.media.length > 0 || activity.video ? (
																			<MediaRenderer
																				media={activity.media}
																				photo={activity.photo}
																				video={activity.video}
																				videoThumbnail={activity.video_thumb}
																			/>
																		) : null}
																	</div>
																</div>
															</div>
														</div>
													);
												})}
											</Fragment>
										))
									);
								})}
							</div>
							{/* TODO: Add send pdf email functionality back in when a solution to broken images is implemented */}
							{/* {studentActivity.length > 0 && (
								<div className="self-end">
									<span
										style={{
											display: 'flex',
											justifyContent: 'center',
											lineHeight: '29px',
											margin: 'auto',
										}}
									>
										<span className="mx-4">
											{sendLoader ? (
												<div className="circle-bar">
													<CircularProgress size={35} />
												</div>
											) : (
												<CustomButton
													onClick={() => {
														sendPdfEmail();
														setSendingLoader(true);
													}}
													variant="secondary"
													height="43"
													width="140px"
													fontSize="15px"
												>
													Send
												</CustomButton>
											)}
										</span>
									</span>
								</div>
							)} */}
						</>
					)}
				</div>
			</div>
		</ModalBase>
	);
};

export default ActivityViewModal;
